import { mutations } from '../../../api';
import { useCallback } from 'react';
import { getDocumentRevisions } from './getDocumentRevisions';
import { useMutation, useApolloClient } from '@apollo/client';

const useDocumentRevisionHistory = (documentId: string | undefined) => {
  const apolloClient = useApolloClient();
  const [updateDocumentRevisions] = useMutation(mutations.updateDocumentRevisions);

  const getDocumentRevisionsCallback = useCallback(async () => {
    if (!documentId) return [];
    return await getDocumentRevisions(documentId)(apolloClient);
  }, [documentId]);

  return {
    getDocumentRevisions: getDocumentRevisionsCallback,
    updateDocumentRevisions,
  };
};

export default useDocumentRevisionHistory;
